<template>
  <v-combobox
    :key="nonce"
    v-model="model"
    :filter="filter"
    :hide-no-data="!search"
    :items="items"
    :search-input.sync="search"
    hide-selected
    label="Search for an option"
    multiple
    small-chips
    item-value="name"
    item-text="name"
    outline
  >
    <template #no-data>
      <v-list-tile>
        <span class="subheading">Create</span>
        <v-chip :color="`primary lighten-3`" label small>
          {{ search }}
        </v-chip>
      </v-list-tile>
    </template>
    <template #selection="{ item, parent, selected }">
      <v-chip
        v-if="item === Object(item)"
        :color="`primary lighten-3`"
        :selected="selected"
        label
        small
      >
        <span class="pr-2">
          {{ item.name }}
        </span>
        <v-icon small @click="parent.selectItem(item)">close</v-icon>
      </v-chip>
    </template>
    <template #item="{ index, item }">
      <v-list-tile-content>
        <template v-if="item">
          <template v-if="editing && editing === item">
            <v-text-field
              v-model="editing.name"
              autofocus
              flat
              background-color="transparent"
              hide-details
              solo
              @keyup.enter="edit(index, item)"
            ></v-text-field>
          </template>
          <v-chip v-else :color="`primary lighten-3`" label small>
            {{ item.name }}
          </v-chip>
        </template>
      </v-list-tile-content>
      <v-spacer></v-spacer>
      <v-list-tile-action @click.stop>
        <v-btn icon @click.stop.prevent="edit(index, item)">
          <v-icon>{{ editing !== item ? 'edit' : 'check' }}</v-icon>
        </v-btn>
      </v-list-tile-action>
    </template>
  </v-combobox>
</template>

<script>
import { cloneDeep } from 'lodash'
import ticketApi from '@/api/ticket'
import { handleApiError } from '@/api/util'
import { mapGetters } from 'vuex'
export default {
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      editing: null,
      activator: null,
      index: -1,
      attach: null,
      model: [],
      search: null,
      nonce: 1
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },

  watch: {
    model(val, prev) {
      if (val.length === prev.length) return

      this.model = val.map((v) => {
        if (typeof v === 'string') {
          v = {
            name: v
          }
        }

        return v
      })

      this.$emit('onChangeTag', this.model)
    }
  },
  mounted() {
    this.model =
      this.tags && this.tags.length
        ? this.tags.map((tag) => {
            if (typeof tag === 'string') {
              return {
                name: tag
              }
            } else if (typeof tag === 'object') {
              if (Object.hasOwnProperty.call(tag, 'name')) {
                return tag
              } else if (Object.hasOwnProperty.call(tag, 'text')) {
                return { name: tag.text }
              }
            }
          })
        : []
  },
  methods: {
    edit(index, item) {
      if (!this.editing) {
        this.editing = item
        this.index = index
      } else {
        this.handleUpdateTag(item)
        this.editing = null
        this.index = -1

        this.nonce++
      }
    },
    async handleUpdateTag(item) {
      const tags = cloneDeep(this.items)
      const tagIndex = tags.findIndex((tag) => {
        return tag && item && tag.name.toLowerCase() == item.name.toLowerCase()
      })
      if (tagIndex != -1) {
        const newtag = cloneDeep(this.editing)
        const result = await this.handleEditTicketTag(tags[tagIndex], newtag)
        if (result) {
          tags[tagIndex] = newtag
          this.$store.commit('SET_TICKET_TAGS_FULL', tags)
        }
      }
    },
    async handleEditTicketTag(item, newVal) {
      try {
        if (item && newVal) {
          const response = await ticketApi.putEditTicketTag({
            data: { pageid: this.selectedBot.pageid, id: item.id, ticket_tag: newVal.name }
          })
          if (response.status == 200 || response.status == 204) {
            return true
          }
        }
      } catch (error) {
        handleApiError(error)
        return false
      }
    },
    filter(item, queryText, itemText) {
      if (item.header) return false

      const hasValue = (val) => (val != null ? val : '')

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/TicketTags.vue